import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toastMessage } from 'Containers/Toast/actions';
import Toast from 'Components/Toast';
import withErrorBoundary from 'HOC/ErrorBoundary';

const ToastContainer: FC<any> = () => {
  const Selector = useSelector((selectors: any) => selectors);
  const Dispatch = useDispatch();
  const onComplete = () => Dispatch(toastMessage({ message: '' }));
  return (
    <>
      {Selector.toast.message.length > 0 && (
        <Toast
          visible={Selector.toast.message.length > 0}
          text={Selector.toast.message}
          position={Selector.toast.position}
          duration={Selector.toast.duration}
          onComplete={onComplete}
        />
      )}
    </>
  );
};

export default withErrorBoundary(ToastContainer);
